<template>
  <div>
    <div class="page-header clear-filter" filter-color="black3">
      <parallax
        v-bind:useScroll="false"
        class="page-header-image"
        style="background-image:url('/img/img_map.png')"
      ></parallax>
      <div class="map-area">
        <div class="map-title">
          <h6 class="card-title mb-4">Zone #{{currentZone}}</h6>
        </div>
        <!-- <div class="map-title-devrank">
              <b-form-checkbox id="checkbox1" v-model="visibleDevRank" value="on" unchecked-value="off">{{$t('map_devrank')}}</b-form-checkbox>
        </div>-->
        <div class="map-scroll-stage">
          <map-layer
            ref="mapLayer"
            :viewport="viewport"
            v-bind:columnCount="32"
            v-bind:rowCount="32"
            v-bind:tileWidth="25"
            v-bind:tileHeight="25"
          ></map-layer>
          <grid-layer
            :viewport="viewport"
            :visible="showGridChecked"
            v-bind:visibleDevRank="visibleDevRank"
            v-if="renderGrid"
            v-bind:mapType="1"
          ></grid-layer>
        </div>
      </div>
      <div class="minimap-area">
        <!-- <div class="minimap-title">
                <h5 class="card-title mb-4">World Map</h5>
        </div>-->
        <div class="minimap-scroll-stage">
          <map-layer
            ref="mapLayer"
            :viewport="viewport"
            v-bind:columnCount="8"
            v-bind:rowCount="8"
            v-bind:tileWidth="40"
            v-bind:tileHeight="40"
          ></map-layer>
          <grid-layer
            :viewport="viewport"
            :visible="showGridChecked"
            v-if="renderGrid"
            v-bind:selectedLandId="selectedLandId"
            v-bind:columnCount="8"
            v-bind:rowCount="8"
            v-bind:tileWidth="40"
            v-bind:tileHeight="40"
            v-bind:mapType="0"
          ></grid-layer>
        </div>
      </div>
      <div class="gamemap-area" v-if="selectedLandId != 0">
        <div class="gamemap-title">
          <h6 class="card-title mb-4">{{$t('Game Field')}}</h6>
        </div>
        <div class="gamemap-scroll-area">
          <div v-for="object in trees" v-bind:key="object._id">
            <div
              v-bind:style="{position: 'absolute', left:`${object.x}px`, top:`${object.y}px`, width:'40px', height:'40px'}"
            >
              <img v-bind:src="`/img/Tiles/fo_${object.code}.png`" width="100%" />
            </div>
          </div>
          <div v-for="object in objects" v-bind:key="object._id">
            <div
              v-bind:style="{position: 'absolute', left:`${object.x}px`, top:`${object.y}px`, width:'40px', height:'40px'}"
            >
              <img
                v-if="object.display != null"
                v-bind:src="`/img/object_${object.display}.png`"
                width="100%"
              />
              <h5
                v-if="object.display != null"
                style="width:100%; height: 100%; text-align: center; margin-top: -13px; color: white; font-size: 0.7em;"
              >Lv.{{object.level}}</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="cart-area">
        <div class="cart-item" v-for="cart in carts" v-bind:key="cart._id">
          <span>[{{cart._id}}]</span>
          <span>Rank {{cart.rank}}</span>
          <span>{{PRICES[cart.rank]}} ETH</span>
          <span @click="moveCart(cart)">이동</span>
          <span @click="removeCart(cart)">삭제</span>
        </div>
        <div
          @click="buy()"
          style="width: 144px; height: 68px; background-image: url('/img/btn_144.png'); font-size: 1.2em;
                  font-weight: 400;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  text-align: center;
                  color: #fff568; padding-top: 20px;margin:auto;left:0;right:0;"
          class="btn"
        >
          {{$t('Buy')}}
          <br />
          {{total}} ETH
        </div>
        <div
          @click="clearCart()"
          style="width: 144px; height: 68px; background-image: url('/img/btn_144.png'); font-size: 1.2em;
                  font-weight: 400;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  text-align: center;
                  color: #fff568; padding-top: 20px;margin:auto;left:0;right:0;"
          class="btn"
        >{{$t('Clear')}}</div>
      </div>
      <div class="land-info-area" v-if="selectedLandId != 0">
        <div class="land-info-title">
          <h6 class="card-title mb-4">{{$t('Land')}} #{{landInfo.landId}}</h6>
        </div>
        <table style="width: 100%; margin-top: 20px;">
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Dev. Rank')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.devRank}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Name')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.landName}}</h6>
            </td>
          </tr>
          <tr style="height: 56px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Price')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6
                class="card-title3"
                v-if="landInfo.owner == null"
              >{{PRICES[landInfo.attributes.devRank]}} ETH</h6>
              <h6 class="card-title3" v-if="landInfo.owner != null">{{$t('soldout')}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Comment')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.profile.comment}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Color')}}</h6>
            </td>
            <td style="width: 70%;">
              <div
                v-bind:style="{width: `24px`, height: `24px`, 'border': '1px solid #000000', 'background-color': `${this.getHexColor(landInfo.attributes.profile.color)}`, 'margin-left':`auto`, 'margin-right':0, 'margin-top':'-10px'}"
              ></div>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Reward')}}</h6>
            </td>
            <td style="width: 70%;"></td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Cumulative')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.stats.token}} ETH</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Unclaimed')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.storage.token}} ETH</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Resources')}}</h6>
            </td>
            <td style="width: 70%;"></td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Cumulative')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.stats.resources}}</h6>
            </td>
          </tr>
          <tr style="height: 27px;">
            <td style="width: 30%;">
              <h6 class="card-title2">{{$t('Unclaimed')}}</h6>
            </td>
            <td style="width: 70%;">
              <h6 class="card-title3">{{landInfo.attributes.storage.resources}}</h6>
            </td>
          </tr>
        </table>
        <div style="position: absolute; bottom: 25px; left: 0px; width: 100%; height: 68px;">
          <table style="width: 100%; height: 100%;">
            <tr>
              <td style="width: 50%; text-align: center;">
                <div
                  @click="addCart()"
                  style="width: 144px; height: 68px; background-image: url('/img/btn_144.png'); font-size: 1.2em;
                  font-weight: 400;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  text-align: center;
                  color: #fff568; padding-top: 20px;"
                  class="btn"
                >{{$t('Add to cart')}}</div>
              </td>
              <td style="width: 50%; text-align: center;">
                <div
                  @click="goToLandPage()"
                  style="width: 144px; height: 68px; background-image: url('/img/btn_144.png'); font-size: 1.2em;
                  font-weight: 400;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: normal;
                  text-align: center;
                  color: #fff568; padding-top: 20px;"
                  class="btn"
                >{{$t('Details')}}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { Parallax, Button } from "@/components";
import axios from 'axios'
import config from '../config.js';
import MapLayer from '../components/partials/MapLayer.vue';
import GridLayer from '../components/partials/GridLayer.vue';
// import { OrderSide } from 'opensea-js/lib/types';
// import { OpenSeaPort, Network } from 'opensea-js';
import KingdomLandSale from './KingdomLandSale.json';
import Web3 from 'web3';
const NETWORK = "rinkeby";//4;//process.env.NETWORK
const API_KEY = "714121e92d814fed8234b8168ffa8f9c";
const web3Provider = window.ethereum;
var web3;//= new Web3('ws://localhost:8546');
var contract;
let seaport;
if (web3Provider) {
  // seaport = new OpenSeaPort(web3Provider,  {
  //   networkName: NETWORK === 'mainnet' ? Network.Main : Network.Rinkeby,
  //   apiKey: API_KEY
  // });
  web3 = new Web3(web3Provider);
  contract = new web3.eth.Contract(KingdomLandSale.abi, KingdomLandSale.networks[4].address);

}
const HIDE_GRID_WHEN_SCROLLING = true;
function ETH(value) {
  return web3.utils.fromWei(value, 'ether');
}
function WEI(value) {
  return web3.utils.toWei(value, 'ether');
}
export default {
  name: 'Map',
  components: { MapLayer, GridLayer, Parallax, [Button.name]: Button },
  data: () => ({
    viewport: {
      left: 0,
      top: 0,
      width: 0,
      height: 0,
    },
    isScrolling: false,
    scrollingTimer: null,
    mousedownFlag: false,
    mousedownOffset: null,
    showGridChecked: true,
    visibleDevRank: 'off',
    selectedLandId: 0,
    landInfo: {
    },
    carts: [],
    total: 0,
    objects: [],
    trees: [],
    PRICES: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
  }),
  computed: {
    currentLandId() {
      return this.$store.state.area.selectedLand;
    },
    currentZone() {
      return this.$store.state.map.currentZone;
    },
    renderGrid() {
      return !HIDE_GRID_WHEN_SCROLLING || !this.isScrolling;
    }
  },
  mounted() {
    // this.$nextTick(() => {      
    // })
  },
  watch: {
    async currentLandId(val) {
      const treeCodes = [501, 502, 503, 504, 505, 601, 602, 603];
      this.trees = [];
      for (let i = 0; i < 10; ++i) {
        this.trees.push({
          _id: i,
          code: treeCodes[Math.floor(Math.random() * treeCodes.length)],
          x: Math.floor(Math.random() * 8) * 40,
          y: Math.floor(Math.random() * 8) * 40
        })
      }
      this.landInfo = await this.getLandInfo(val[0]);
      this.objects = await this.getFieldObjects(val[0]);
      this.selectedLandId = this.landInfo.landId;
    }
  },
  created: async function () {

    // var result = await contract.methods.getPrices(10).call();
    // this.PRICES = result.map(x => Number(ETH(x)).toFixed(4));

    var saved = localStorage.getItem("cart");
    if (saved != null) {
      this.carts = JSON.parse(saved);
      this.computeCart();
    }

  },
  methods: {
    goToLandPage: function () {
      //this.$router.push(`/land/${this.selectedLandId}`)
      window.open(`${config.web.url}/land/${this.selectedLandId}`, '_blank');
    },
    moveCart: function (cart) {
      console.log(cart);
      this.$store.commit("clickWorldMap", {
        key: cart.zone
      });
      setTimeout(() => {

        this.$store.commit("clickMap", {
          key: cart.zone,
          land: cart.land
        });
        this.selectedLandId = cart.land[0];
      }, 4000);
    },
    addCart: function () {
      console.log(this.$store.state.map.currentZone);
      console.log(this.$store.state.area.selectedLand);
      if (this.carts.filter(e => e._id == this.selectedLand).length > 0)
        return;

      this.carts.push({
        _id: this.$store.state.area.selectedLand[0],
        zone: this.$store.state.map.currentZone,
        land: this.$store.state.area.selectedLand,
        rank: this.landInfo.attributes.devRank
      });
      this.computeCart();
      this.saveCart();
    },
    removeCart: function (cart) {
      var index = this.carts.indexOf(cart);
      if (index < 0)
        return;
      this.carts.splice(index, 1);
      this.computeCart();
      this.saveCart();
    },
    computeCart: function () {
      var sum = 0;
      for (var cart of this.carts)
        sum += Number(this.PRICES[cart.rank]);
      this.total = sum.toFixed(4);
    },
    clearCart: function () {
      this.carts = [];
      this.total = 0;
      this.saveCart();
    },
    saveCart: function () {
      localStorage.setItem("cart", JSON.stringify(this.carts));
      console.log("SAVE CART");
    },
    buy: async function () {
      const accounts = await window.ethereum.enable();
      // var price = this.PRICES[this.carts[0].rank];
      var ids = this.carts.map(cart => cart._id % 100000);
      var PRICES = this.PRICES;
      var price = this.carts.reduce(function (accumulator, element) {
        console.log(PRICES[element.rank])
        return accumulator + Number(PRICES[element.rank]);//.toNumber();
      }, 0);
      console.log(price);
      console.log(this.carts[0]._id % 100000);
      console.log(contract.options.address);
      // var result = await this.send(contract.methods.buy(this.carts[0]._id%100000).encodeABI(), price);
      var result = await this.send(contract.methods.buys(ids).encodeABI(), price);
      console.log(result);
      //   var result = await contract.methods.getPrices(10).call();
      // this.PRICES = result.map(x => Number(ETH(x)).toFixed(4));
      // const accounts = await window.ethereum.enable();
      // const oneItem = { side: OrderSide.Sell, asset_contract_address: "0x901767e4339585a061d3fc65e63cc2dc3cf619c9",  token_id: "20001" };
      // const bundleItem = {side: OrderSide.Sell, bundled:true,  slug: "league-of-kingdom-land-bundles-134"};
      // const order = await seaport.api.getOrder(bundleItem);
      // const accountAddress = accounts[0];
      // console.log(order);
      // const transactionHash = await seaport.fulfillOrder({ order,accountAddress })
      // console.log(transactionHash);
    },
    send: async function (data, value, callback) {
      const param = {
        to: contract.options.address,
        from: window.ethereum.selectedAddress,
        value: WEI(value.toString()), // Only required to send ether to the recipient from the initiating external account.
        data: data,

        // nonce: '0x00', // ignored by MetaMask
        // gasPrice: ETH(0.000001), // customizable by user during MetaMask confirmation.
        // gas: web3.toHex(21000),  // customizable by user during MetaMask confirmation.
        // chainId: 3
      }
      console.log(param);
      try {
        var result = await web3.eth.sendTransaction(param);
        return result;
      }
      catch (e) {
        console.log(e);
        return {};

      }
    },
    getEtherScanUrl: function (address) {
      return `${config.etherscan.account}/${address}`;
    },
    getHexColor: function (number) {
      return "#" + ((number) >>> 0).toString(16).slice(-6);
    },
    getLandInfo: function (landId) {
      console.log('getLandInfo - ', landId);
      return new Promise((resolve, reject) => {
        axios.get(`${config.api.game_url}/land/info?landId=${landId}`, {}).then((ret) => {
          if (ret.data.result == true) {
            resolve(ret.data.land);
          }
          else {
            reject();
          }
        })
      })
    },
    getFieldObjects: function (landId) {
      console.log('getFieldObjects - ', landId);
      return new Promise((resolve, reject) => {
        axios.get(`${config.api.game_url}/field/fieldobjects?landId=${landId}`, {}).then((ret) => {
          if (ret.data.result == true) {
            let objects = ret.data.objects;
            landId = landId % 100000;
            let landX = landId % 256;
            let landY = Math.floor(landId / 256);
            let x = landX * 8;
            let y = landY * 8;
            for (let i = 0; i < objects.length; ++i) {
              objects[i].x = (objects[i].loc[1] - x) * 40 - 10;
              objects[i].y = (7 - (objects[i].loc[2] - y)) * 40;
              if (objects[i].code >= 20100101 && objects[i].code <= 20100104) {
                objects[i].display = objects[i].code - 20100100;
              }
              else if (objects[i].code >= 20200101 && objects[i].code <= 20200103) {
                objects[i].display = objects[i].code - 20200100 + 4;
              }
              else if (objects[i].code == 20200201) {
                objects[i].display = 8;
              }
            }
            resolve(objects);
          }
          else {
            reject();
          }
        })
      })
    },
    onMousedown(e) {
      this.mousedownFlag = true;
      this.mousedownOffset = {
        x: e.offsetX,
        y: e.offsetY,
      };
      this.isDragging = false;
    },
    onMousemove(e) {
      if (!this.mousedownFlag) {
        return;
      }
      if (this.isDragging) {
        this.adjustViewportPosition(-e.originalEvent.movementX, -e.originalEvent.movementY, 1);
      } else if (Math.abs(this.mousedownOffset.x - e.offsetX) + Math.abs(this.mousedownOffset.y - e.offsetY) > 2) {
        this.isDragging = true;
      }
    },
    onMouseup() {
      this.mousedownFlag = false;
      this.isDragging = false;
    },
    onClickMap() {
    },
  }
}
</script>

<style scoped>
.map-pos {
  position: absolute;
  right: 255px;
  top: 10px;
  font-size: 14px;
  color: #fff;
  user-select: none;
  text-align: right;
}
.map-title {
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  color: #00ff00;
  width: 600px;
  height: 50px;
  text-align: left;
}
.map-title-devrank {
  position: absolute;
  top: 80px;
  left: 255px;
  width: 800px;
  height: 50px;
  text-align: right;
}
.map-area {
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  width: 822px;
  height: 843px;
  background-image: url("/img/frame_zone.png");
  overflow: none;
}
.map-scroll-stage {
  position: absolute;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  width: 800px;
  height: 800px;
  overflow: none;
}
.cart-area {
  position: absolute;
  top: 480px;
  right: calc(50% + 436px);
  width: 328px;
  height: 328px;
  background-image: url("/img/frame_world.png");
  overflow: none;
}
.cart-title {
  position: absolute;
  top: 120px;
  width: 328px;
  height: 50px;
  text-align: center;
}
.cart-item {
  color: white;
}
.minimap-area {
  position: absolute;
  top: 120px;
  right: calc(50% + 436px);
  width: 328px;
  height: 328px;
  background-image: url("/img/frame_world.png");
  overflow: none;
}
.minimap-title {
  position: absolute;
  top: 120px;
  width: 328px;
  height: 50px;
  text-align: center;
}
.minimap-scroll-stage {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 320px;
  height: 320px;
  overflow: none;
}
.land-info-title {
  position: absolute;
  top: 3px;
  width: 320px;
  height: 50px;
  text-align: center;
  color: white;
}
.land-info-area {
  position: absolute;
  top: 473px;
  left: calc(50% + 436px);
  width: 328px;
  height: 471px;
  overflow: none;
  background-image: url("/img/frame_field_info.png");
  padding: 10px;
}
.gamemap-area {
  position: absolute;
  top: 100px;
  left: calc(50% + 436px);
  width: 328px;
  height: 349px;
  background-image: url("/img/frame_field.png");
  overflow: none;
}
.gamemap-title {
  position: absolute;
  top: 3px;
  width: 320px;
  height: 50px;
  text-align: center;
  color: white;
}
.gamemap-scroll-area {
  position: absolute;
  top: 25px;
  left: 4px;
  width: 320px;
  height: 320px;
  background-image: url("/img/map/map_01.png");
  overflow: none;
}
.map-area.dragging {
  cursor: move;
}
.map-selector {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 150px;
  font-size: 12px;
  user-select: none;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 3px;
  color: #000;
  border: 1px solid #000;
}
.map-selector ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.urban-list {
}
.urban-list .urban-item {
  position: relative;
}
.urban-list .urban-item > span {
  display: block;
  padding: 10px;
  border-top: 1px solid #ccc;
  cursor: pointer;
}
.urban-list .urban-item:first-child > span {
  border-top: none;
}
.urban-list .urban-item::after {
  content: "+";
  position: absolute;
  right: 10px;
  top: 5px;
  font-size: 25px;
  color: #666;
}
.urban-list .urban-item.active::after {
  content: "-";
}
.map-list {
  max-height: 400px;
  overflow-y: auto;
  background-color: #f0f0f0;
}
.map-list .map-item {
  display: none;
}
.map-list .map-item a {
  display: block;
  padding: 5px;
  border-top: 1px solid #ccc;
  font-size: 11px;
  color: #333;
  text-decoration: none;
  outline: none;
}
.map-list .map-item a:hover {
  background-color: #e5e5e5;
}
.map-list .map-item a::before {
  content: "-";
  display: inline-block;
  padding: 0 5px;
}
.map-list .map-item.active a {
  background-color: #e5e5e5;
}
.map-list .map-item.active a::before {
  content: ">>";
}
.urban-list .urban-item.active .map-item {
  display: block;
}
.map-list .map-item.active {
  display: block;
}
table,
th,
td {
  border: 0px solid white !important;
  min-width: 0px !important;
  min-height: 0px !important;
}
</style>